// extracted by mini-css-extract-plugin
export default {"container":"ShopBigRetailerManagement_container__LYuiO","wrapperTag":"ShopBigRetailerManagement_wrapperTag__Gm-gv","wrapperInput":"ShopBigRetailerManagement_wrapperInput__CQ4ZV"};